import { nanoid } from "nanoid";
import { call, takeLeading, updateStore } from "starfx";

import { schema as db } from "@app/statefx/schema";

import { xThunk } from "../xapis";

import type { Operation } from "starfx";
export const aquireLockThunk = xThunk.create<{
  op: "build" | "reload" | "deploy" | "cache" | "bootup";
}>("/prc-lock/aquireLock", { supervisor: takeLeading }, function* (ctx, next) {
  const newLock = `$:${ctx.payload.op}:>${nanoid()}`;
  yield* db.update(db.lock.set(newLock));
  yield* next();
});

export const aquireLock = function* (
  op: "build" | "reload" | "deploy" | "cache" | "bootup"
): Operation<string> {
  // generate random unique string: ... yeah. why?
  const newLock = `$:${op}:>${nanoid()}`;
  yield* call(() =>
    window.fx.run(function* () {
      yield* updateStore(db.lock.set(newLock));
    })
  );
  return newLock;
};

export const releaseLock = function* (): Operation<void> {
  console.log("releaseLock");
  yield* call(() =>
    window.fx.run(function* () {
      yield* updateStore(db.lock.set(null));
    })
  );
};
